export default __webpack_public_path__ + "static/LTZ_DESKTOP-XL-c102fdaac29148e1abef644302dcece1.jpg";